import ListPreviewRoot from "./ListPreviewRoot";
import ListPreviewRow from "./ListPreviewRow";

const ListPreview = {
  Root: ListPreviewRoot,
  Row: ListPreviewRow,
};

export default ListPreview;
